import axios from 'axios';
import { ApiResponse, zps_wp } from '../zps';
import { IUser, Permission } from '../user';

export interface Distribuition {
  emails: string[];
  entid: number;
  eventCode: number;
  eventDescription: string;
  id: string;
  permissions: Permission[];
  users: IUser[];
}

export interface Event {
  act: { destDesisor: boolean; destMonitor: boolean; destDispacter: boolean; destDistributionList: boolean };
  actCounter: number;
  description: string;
  eventCode: number;
  eventType: number;
}

export interface DistribuitionsResponse extends ApiResponse {
  list: Distribuition[];
  totalRows: number;
}

export interface EventsResponse extends ApiResponse {
  events: Event[];
}

export interface DistribuitionInfoResponse extends ApiResponse {
  list: Distribuition[];
  totalRows: number;
}

export interface DistribuitionRequests {
  emails: string[];
  eventCode: number;
  eventDescription: string;
  id: number;
  permissions: Permission[];
  users: IUser[];
}

export const fetchDistributionList = (
  offset: number,
  limit: number,
  totalRows: boolean,
  controller: AbortController,
  uid?: number
): Promise<DistribuitionsResponse> => {
  const url =
    `${zps_wp}/api/distribution-list?offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    (uid ? `&uid=${uid}` : '');

  return axios.get<DistribuitionsResponse>(url, { signal: controller.signal }).then(res => res.data);
};

export const fetchDistributionInfo = (id: number, controller: AbortController): Promise<DistribuitionInfoResponse> => {
  const url = `${zps_wp}/api/distribution-list?id=${id}`;
  return axios.get<DistribuitionInfoResponse>(url, { signal: controller.signal }).then(res => res.data);
};

export const fetchEventList = (controller: AbortController): Promise<EventsResponse> => {
  return axios
    .get<EventsResponse>(`${zps_wp}/api/distribution-list/event`, { signal: controller.signal })
    .then(res => res.data);
};

export const addDistribuition = (request: DistribuitionRequests, controller: AbortController): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/distribution-list`;
  return axios.post<ApiResponse>(url, request, { signal: controller.signal }).then(res => res.data);
};

export const updateDistribuition = (
  request: DistribuitionRequests,
  controller: AbortController
): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/distribution-list`;
  return axios.put<ApiResponse>(url, request, { signal: controller.signal }).then(res => res.data);
};

export const deleteDistribuition = (id: string): Promise<ApiResponse> => {
  const url = `${zps_wp}/api/distribution-list?id=${id}`;
  return axios.delete<ApiResponse>(url).then(res => res.data);
};
